import { FormatNumberWithCommas } from "../../../../shared/scripts/number-functions";
import { AggregatedParticipants } from "./enrollment.entities";


export class ProgressBarSection {

    constructor() { }

    updateProgressBarData(aggregatedParticipants: AggregatedParticipants): void {
        this.updateRaceData(aggregatedParticipants.Race, aggregatedParticipants.Count);
        this.updateHispanicData(aggregatedParticipants.Hispanic, aggregatedParticipants.Count);
        this.updateNonWhiteHispanicData(aggregatedParticipants.NonWhiteHispanic, aggregatedParticipants.Count);
        this.updateSexData(aggregatedParticipants.Sex, aggregatedParticipants.Count);
        this.updateAgeData(aggregatedParticipants.Age, aggregatedParticipants.Count);
    }

    private setProgressBarValue(label: string, valueElementId: string, labelElementId: string, percent: number, count: number): void {
        //both title attributes need to be updated for tooltip to refresh
        let tooltipText: string = label + " (" + Math.round(percent) + "%; n=" + FormatNumberWithCommas(String(count)) + ")";
        $(valueElementId).css('width', percent + '%').attr('aria-valuenow', percent).attr('data-title', tooltipText).attr('data-original-title', tooltipText);
        $(labelElementId).css('width', percent + '%').attr('aria-valuenow', percent);
        $(valueElementId).tooltip();

        if ((label == "Unknown" && percent < 12) || (label != "Unknown" && percent < 10)) {
            $(labelElementId).text("");
            $(valueElementId).text("");

        }
        else {
            $(labelElementId).text(label);
            $(valueElementId).text(Math.round(percent) + "%");
        }
    }


    private updateRaceData(data: number[], totalCount: number): void {

        if (totalCount == 0) { this.hideProgressBar('progressbar-race'); $('#progressbar-message-race').show(); return; }
        else { $('#progressbar-message-race').hide(); this.showProgressBar('progressbar-race'); }

        this.setProgressBarValue('AIAN', '#value-race-aian', '#label-race-aian', (data[1] / totalCount) * 100, data[1]);
        this.setProgressBarValue('Asian', '#value-race-asian', '#label-race-asian', (data[2] / totalCount) * 100, data[2]);
        this.setProgressBarValue('Black', '#value-race-black', '#label-race-black', (data[3] / totalCount) * 100, data[3]);
        this.setProgressBarValue('MENA', '#value-race-mena', '#label-race-mena', (data[4] / totalCount) * 100, data[4]);
        this.setProgressBarValue('NHPI', '#value-race-nhpi', '#label-race-nhpi', (data[5] / totalCount) * 100, data[5]);
        this.setProgressBarValue('White', '#value-race-white', '#label-race-white', (data[6] / totalCount) * 100, data[6]);
        this.setProgressBarValue('Multiple', '#value-race-multiple', '#label-race-multiple', (data[0] / totalCount) * 100, data[0]);
        this.setProgressBarValue('Other', '#value-race-other', '#label-race-other', (data[8] / totalCount) * 100, data[8]);
        this.setProgressBarValue('Unknown', '#value-race-unknown', '#label-race-unknown', (data[7] / totalCount) * 100, data[7]);
    }

    private updateHispanicData(data: number[], totalCount: number): void {

        if (totalCount == 0) { this.hideProgressBar('progressbar-hispanic'); $('#progressbar-message-hispanic').show(); return; }
        else { $('#progressbar-message-hispanic').hide(); this.showProgressBar('progressbar-hispanic'); }

        this.setProgressBarValue('Hispanic', '#value-hispanic-yes', '#label-hispanic-yes', ((data[1] / totalCount) * 100), data[1]);
        this.setProgressBarValue('Not Hispanic', '#value-hispanic-no', '#label-hispanic-no', ((data[0] / totalCount) * 100), data[0]);
        this.setProgressBarValue('Unknown', '#value-hispanic-unknown', '#label-hispanic-unknown', ((data[2] / totalCount) * 100), data[2]);
    }

    private updateNonWhiteHispanicData(data: number[], totalCount: number): void {

        if (totalCount == 0) { this.hideProgressBar('progressbar-nonwhitehispanic'); $('#progressbar-message-nonwhitehispanic').show(); return; }
        else { $('#progressbar-message-nonwhitehispanic').hide(); this.showProgressBar('progressbar-nonwhitehispanic'); }

        this.setProgressBarValue('Yes', '#value-nonwhitehispanic-yes', '#label-nonwhitehispanic-yes', ((data[1] / totalCount) * 100), data[1]);
        this.setProgressBarValue('No', '#value-nonwhitehispanic-no', '#label-nonwhitehispanic-no', ((data[0] / totalCount) * 100), data[0]);
        this.setProgressBarValue('Unknown', '#value-nonwhitehispanic-unknown', '#label-nonwhitehispanic-unknown', ((data[2] / totalCount) * 100), data[2]);
    }

    private updateSexData(data: number[], totalCount: number): void {
        if (totalCount == 0) { this.hideProgressBar('progressbar-sex'); $('#progressbar-message-sex').show(); return; }
        else { this.showProgressBar('progressbar-sex'); $('#progressbar-message-sex').hide(); }

        this.setProgressBarValue('Female', '#value-sex-female', '#label-sex-female', ((data[0] / totalCount) * 100), data[0]);
        this.setProgressBarValue('Male', '#value-sex-male', '#label-sex-male', ((data[1] / totalCount) * 100), data[1]);
        this.setProgressBarValue('Unknown', '#value-sex-unknown', '#label-sex-unknown', ((data[4] / totalCount) * 100), data[4]);
    }

    private updateAgeData(data: number[], totalCount: number): void {
        if (totalCount == 0) { this.hideProgressBar('progressbar-age'); $('#progressbar-message-age').show(); return; }
        else { $('#progressbar-message-age').hide(); this.showProgressBar('progressbar-age'); }

        this.setProgressBarValue('18-45', '#value-age-18_45', '#label-age-18_45', (data[0] / totalCount) * 100, data[0]);
        this.setProgressBarValue('46-65', '#value-age-46_65', '#label-age-46_65', (data[1] / totalCount) * 100, data[1]);
        //this.setProgressBarValue('51-70', '#value-age-51_70', '#label-age-51_70', (data[2] / totalCount) * 100, data[2]);
        this.setProgressBarValue('>65', '#value-age-more65', '#label-age-more65', (data[2] / totalCount) * 100, data[2]);
        this.setProgressBarValue('Unknown', '#value-age-unknown', '#label-age-unknown', (data[3] / totalCount) * 100, data[3]);
    }


    private hideProgressBar(id: string): void {
        $('#' + id).removeClass('d-flex');
        $('#' + id).addClass('d-none');

    }
    private showProgressBar(id: string): void {
        $('#' + id).removeClass('d-none');
        $('#' + id).addClass('d-flex');
    }
}